/** Class used to finalize orders referring to shop. */

import {Product} from "../product/product";

export class Order{

    /** Total amount of products added. */
    public quantity: number;

    /** Total order amount. */
    public grossValue: number;

    /** List of purchased products. */
    public products: Array<Product>;

    public id: number;

    constructor(
        quantity = NaN,
        grossValue = NaN,
        products = new Array<Product>(),
        id = NaN,
    ) {
        this.quantity = quantity;
        this.grossValue = grossValue;
        this.products = products;
        this.id = id;
    }
}
